
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/komodo-wallet/mobile/export-swap-data-from-your-komodo-wallet-mobile-application",
      function () {
        return require("private-next-pages/en/docs/komodo-wallet/mobile/export-swap-data-from-your-komodo-wallet-mobile-application/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/komodo-wallet/mobile/export-swap-data-from-your-komodo-wallet-mobile-application"])
      });
    }
  